import React from 'react';
import moment from 'moment';
import { Row, Col, Icon, Button } from 'antd';
import { connect } from 'react-redux';
import Layout from '../Layout';
import EditForm from '../../components/EditForm';
import CardsList from '../Cards/components/CardsList';
import CategoriesList from '../Categories/components/CategoriesList';
import InfoItem from '../../components/InfoItem';
import { getById, resetState } from '../../modules/clients';
import { getCardsById } from '../../modules/clientCards';

class ClientForm extends EditForm {

  componentDidMount() {
    const { id } = this.props.match.params;

    if (id) {
      this.props.getById(id);
      this.props.getCardsById(id);
    }
  }

  returnGenderValue = (value) => {
    switch (value) {
      case 'm':
        return 'Male';
      case 'f':
        return 'Female';
      case 'u':
        return 'Undisclosed';
    }
  };

  render() {
    const { data } = this.props;
    const cards = this.props.cards.data.results;
    const total = this.props.cards.data.total;
    const dateOfBirth = moment(data.birthday).format('YYYY-MM-DD');
    const genderValue = this.returnGenderValue(data.gender);
    const catList = <CategoriesList catArray={data.categories} className="mt-1-xs" />;

    return (
      <Layout>
        <Button className="buttonSubmit mb-2"
                type="primary"
                onClick={this.goBack}
        >
          <Icon type="arrow-left" />
          Back
        </Button>
        <div className="container">
          <div className="mb-2">
            <span className="fw-600">Date created: </span>{moment(data.created_at).format(
            'YYYY-MM-DD hh:mm A')}
          </div>
          <Row gutter={[16, 16]} className="grid-list-ib text-center-xs">
            <Col>
              <div className="gutter-box p-2">
                <div className="avatar-wrapper m-auto">
                  <img src={data.logo} alt="" className="avatar" />
                </div>
              </div>
            </Col>
            <Col>
              <div className="gutter-box min-w-340 px-2 py-1">
                <InfoItem label="First Name" value={data.first_name} />
                <InfoItem label="Last Name" value={data.last_name} />
                <InfoItem label="Email" value={data.email} isTrimmed maxLength={25} notTrimXs />
                <InfoItem label="Phone Number" value={data.phone_number} />
                <InfoItem label="Birthday" value={dateOfBirth} />
                <InfoItem label="Gender" value={genderValue} />
              </div>
            </Col>
            <Col>
              <div className="gutter-box min-w-264 px-2 py-1">
                <InfoItem label="Categories" value={catList} valueSpan={10} labelSpan={14} />
                <InfoItem label="Cards Count"
                          value={data.cards_count}
                          valueSpan={10}
                          labelSpan={14} />
                <InfoItem label="Friends Count"
                          value={data.friends_count}
                          valueSpan={10}
                          labelSpan={14} />
                <InfoItem label="Leader Place"
                          value={data.leader_place}
                          valueSpan={10}
                          labelSpan={14} />
              </div>
            </Col>
          </Row>
          <Row className="mt-2">
            <CardsList cardsArray={cards} total={total} className="grid-list-ib" />
          </Row>
        </div>
      </Layout>
    );
  }
}

export default connect(
  state => ({
    ...state.clients,
    cards: state.clientCards,
  }),
  {
    getById,
    getCardsById,
    resetState,
  },
)(ClientForm);



// WEBPACK FOOTER //
// ./src/containers/Clients/ClientForm.js